// src/services/bi/KPIsSection.jsx
import React, { useState, useEffect } from 'react';
import KPICard from './KPICard';
import { getKPIs, formatKPIsForDisplay } from './dashboardAiService';

const KPIsSection = () => {
  const [kpis, setKpis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchKPIs();
  }, []);

  const fetchKPIs = async () => {
    try {
      setLoading(true);
      const data = await getKPIs();
      const formatted = formatKPIsForDisplay(data);
      setKpis(formatted);
      setError(null);
    } catch (err) {
      console.error('Erreur chargement KPI:', err);
      setError('Impossible de charger les KPI');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <span>Chargement des KPI...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-box">
        <div className="error-box__title">⚠️ Erreur</div>
        <div className="error-box__message">{error}</div>
      </div>
    );
  }

  return (
    <div className="kpis-section">
      <h2 className="kpis-section__title">📊 Indicateurs clés IA</h2>
      <p className="kpis-section__subtitle">
        Analyse intelligente basée sur le modèle de scoring ML
      </p>
      <div className="kpis-grid">
        {kpis.map((kpi) => (
          <KPICard
            key={kpi.id}
            label={kpi.label}
            icon={kpi.icon}
            value={kpi.value}
            interpretation={kpi.interpretation}
            color={kpi.color}
            trend={kpi.trend}
          />
        ))}
      </div>
    </div>
  );
};

export default KPIsSection;